module.exports = __webpack_public_path__ + "static/spider-545f50032e715bf3d91f563b7a94c68a.jpeg";